import axios from "axios";

async function getDownloadLink(postId, email = '') {
    const params = new URLSearchParams();
    params.append('action', 'generate_temp_link');
    params.append('post_id', postId);
    params.append('nonce', font_api_settings.nonce);

    if (email) params.append('email', email);

    return await axios.post(font_api_settings.ajax_url, params)
        .then(response => response.data)
        .catch(error => {
            console.error(error);
            throw error;
        });
}


document.querySelectorAll('.download-btn').forEach(item => item.addEventListener('click', async function () {
    const post_id = item.getAttribute('data-resource-id');

    const linkData = await getDownloadLink(post_id);

    if (linkData.success) {
        window.location.href = linkData.data.link;
    }
}));

document.querySelectorAll('.download-btn-popup').forEach(item => item.addEventListener('click', async function () {
    document.querySelector('.guest_popup_form [name="resource_id"]').value = item.getAttribute('data-resource-id');
}));

document.querySelector('.guest_popup_form')?.addEventListener('submit', async function (event) {
    event.preventDefault();

    const form_el = this;
    const post_id = form_el.querySelector('[name="resource_id"]').value;
    const email = form_el.querySelector('[name="email"]').value;

    try {
        const linkData = await getDownloadLink(post_id, email);

        if (linkData.success) {
            const guestPopupEl = document.getElementById('guest_popup');
            const guestPopup = bootstrap.Modal.getInstance(guestPopupEl) || new bootstrap.Modal(guestPopupEl);
            guestPopup.hide();

            const thanksPopupEl = document.getElementById('guest_popup_thanks');
            const thanksPopup = new bootstrap.Modal(thanksPopupEl);
            thanksPopup.show();
        }
    } catch (err) {
        console.error(err);
    }
});